import { render, staticRenderFns } from "./trainingstrategy.vue?vue&type=template&id=3bef043a&scoped=true"
import script from "./trainingstrategy.vue?vue&type=script&lang=js"
export * from "./trainingstrategy.vue?vue&type=script&lang=js"
import style0 from "./trainingstrategy.vue?vue&type=style&index=0&id=3bef043a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bef043a",
  null
  
)

export default component.exports